import { statProperties } from "@/components/StatusTag/StatusTag";
import { HourglassOutlined } from "@ant-design/icons";

export default function CalculatingIcon() {
  return (
    <HourglassOutlined
      style={{
        color: statProperties.calculating.color,
      }}
    />
  );
}
